<template>
  <div class="p-0 col-12 animated fadeIn">
    <b-row class="m-0 pb-3">
      <VueRangedatePicker style="background: white;" @selected="onDateSelected" compact :presetRanges="getPresetRange()"></VueRangedatePicker>
    </b-row>
    <div class="row">
      <div class="col-12" style="overflow-x: auto; overflow-y: hidden;">
        <kendo-datasource ref="salesreport"
            :transport-read="salesReport"
            :schema="sales.schema">
        </kendo-datasource>
        <kendo-chart style="height: 400px;min-width: 700px"
            :theme="'material'"
            :data-source-ref="'salesreport'"
            :series="sales.series"
            :series-defaults-type="'column'"
            :series-defaults-stack="true"
            :title="sales.title"
            :legend="sales.legend"
            :value-axis="sales.valueAxis"
            :category-axis="sales.categoryAxis"
            :tooltip="sales.tooltip"
            :chart-area="sales.chartArea">
        </kendo-chart>
      </div>
      <div class="col-12" style="margin-top: 20px;overflow-x:auto; overflow-y: hidden;">
        <kendo-datasource ref="topCS"
            :transport-read="topCS"
            :schema="product.schema">
        </kendo-datasource>
        <kendo-chart style="height: 400px;min-width: 500px"
            :theme="'bootstrap'"
            :data-source-ref="'topCS'"
            :series="salesPerson.series"
            :title="salesPerson.title"
            :value-axis="salesPerson.valueAxis"
            :category-axis="salesPerson.categoryAxis"
            :legend="{visible: false}">
        </kendo-chart>
      </div>
      <div class="col-12 col-md-6" style="margin-top: 20px; overflow-x: auto; overflow-y: hidden;">
        <kendo-datasource ref="channelreport"
            :transport-read="channelReport"
            :schema="channel.schema">
        </kendo-datasource>
        <kendo-chart style="height: 400px;min-width: 500px"
            :theme="'metro'"
            :data-source-ref="'channelreport'"
            :series="channel.series"
            :title="channel.title"
            :value-axis="sales.valueAxis"
            :category-axis="channel.categoryAxis"
            :legend="channel.legend">
        </kendo-chart>
      </div>
      <div class="col-12 col-md-6" style="margin-top: 20px;overflow-x:auto; overflow-y: hidden;">
        <kendo-datasource ref="topProduct"
            :transport-read="topProduct"
            :schema="product.schema">
        </kendo-datasource>
        <kendo-chart style="height: 400px;min-width: 500px"
            :theme="'bootstrap'"
            :data-source-ref="'topProduct'"
            :series="product.series"
            :title="product.title"
            :value-axis="product.valueAxis"
            :category-axis="product.categoryAxis"
            :legend="{visible: false}">
        </kendo-chart>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VueRangedatePicker from 'vue-rangedate-picker'
const n = new Date()

export default {
  name: 'dashboard',
  components: {
    VueRangedatePicker
  },
  data () {
    return {
      // data here
      start: new Date(n.getFullYear(), n.getMonth(), 1),
      end: new Date(n.getFullYear(), n.getMonth(), n.getDate()),
      button: {
        name: 'Add Sales',
        icon: 'fa fa-cart-plus',
        url: '/sales/add'
      },
      sales: {
        seriesDefaults: {
          type: 'column',
          stacked: true
        },
        series: [
          {
            name: 'Retail',
            field: 'retail',
            categoryField: 'date',
            labels: {
              visible: false,
              color: '#A5A5A5',
              font: '10px Roboto !important',
              template: '#= kendo.toString(Number(value / 1000000).toFixed(1)) #',
              visual: function (e) {
                if (parseInt(e.text) > 10) {
                  return e.createVisual()
                }
              }
            }
          },
          {
            name: 'Reseller',
            field: 'reseller',
            categoryField: 'date',
            labels: {
              visible: false,
              color: '#A5A5A5',
              font: '10px Roboto !important',
              template: '#= kendo.toString(Number(value / 1000000).toFixed(1)) #',
              visual: function (e) {
                if (parseInt(e.text) > 10) {
                  return e.createVisual()
                }
              }
            }
          },
          {
            name: 'Consignment',
            field: 'consignment',
            categoryField: 'date',
            labels: {
              visible: false,
              color: '#A5A5A5',
              font: '10px Roboto !important',
              template: '#= kendo.toString(Number(value / 1000000).toFixed(1)) #',
              visual: function (e) {
                // only display value that are more than 10 Million
                if (parseInt(e.text) > 0) {
                  return e.createVisual()
                }
              }
            }
          },
          {
            name: 'Dropship',
            field: 'dropship',
            categoryField: 'date',
            labels: {
              visible: false,
              color: '#A5A5A5',
              font: '10px Roboto !important',
              template: '#= kendo.toString(Number(stackValue / 1000000), "n1") #'
            }
          },
          {
            name: 'Total Sales',
            field: 'total',
            categoryField: 'date',
            color: '#E9E9E9',
            tooltip: false,
            visibleInLegend: false,
            labels: {
              visible: true,
              color: '#848484',
              font: '10px Roboto !important',
              template: '#= kendo.toString(Number(stackValue / 1000000), "n1") #'
            }
          }
        ],
        title: {
          text: 'SALES PERFOMANCE CURRENT MONTH (VALUE IN MILLION)',
          align: 'left',
          color: '#000',
          font: '14px inherit !important'
        },
        legend: {
          position: 'right',
          offsetX: -100,
          offsetY: -150,
          orientation: 'vertical',
          labels: {
            font: '10px Roboto !important'
          }
        },
        tooltip: {
          visible: true,
          background: 'green',
          font: '14px Roboto !important',
          template: '#= series.name.toUpperCase() #:  #= kendo.toString(Number(value / 1000000).toFixed(2)) #M&nbsp;&nbsp;&nbsp;<i class="fa fa-calendar-alt"></i>&nbsp;#= category.getDate() + "/" + (category.getMonth() +1).toString() #'
        },
        chartArea: {
          background: '#FFFFFF',
          margin: {
            right: -100
          }
        },
        schema: {
          data: 'data',
          parse: function (response) {
            var types = ['retail', 'reseller', 'dropship', 'consignment']
            var data = []
            var i = 0
            while (i < response.data.length) {
              var temp = response.data[i]
              var date = temp['date']
              var momentDate = moment(date)
              var report = {
                date: new Date(parseInt(momentDate.format('YYYY')), parseInt(momentDate.format('MM')) - 1, parseInt(momentDate.format('DD')))
              }
              // var total = 0
              while (i < response.data.length && date === temp['date']) {
                report[temp['sales_type'].toLowerCase()] = Number(temp['sale'])
                // total += Number(temp['sale'])
                temp = response.data[++i]
              }
              for (var ii = 0; ii < types.length; ii++) {
                if (!(types[ii] in report)) {
                  report[types[ii]] = 0.00
                }
              }
              // report['total'] = total
              report['total'] = 0
              data.push(report)
            }
            response.data = data
            return response
          }
        },
        valueAxis: {
          labels: {
            visible: false,
            border: {
              color: 'transparent'
            },
            color: '#848484',
            font: '10px Roboto !important',
            template: '#= kendo.toString(value / 1000000, "n2") #M'
          },
          line: {
            visible: false,
            color: 'transparent',
            width: 0
          },
          majorGridLines: {
            width: 0,
            color: 'transparent'
          },
          minorGridLines: {
            width: 0,
            color: 'transparent'
          }
        },
        categoryAxis: {
          color: '#000',
          labels: {
            font: '12px Roboto !important',
            dateFormats: {
              days: 'dd'
            }
          },
          baseUnit: 'days',
          line: {
            color: '#EAEAEA'
          },
          majorGridLines: {
            width: 0,
            color: 'transparent'
          },
          minorGridLines: {
            width: 0,
            color: 'transparent'
          }
        }
      },
      channel: {
        schema: {
          data: 'data'
        },
        series: [
          {
            field: 'sale',
            categoryField: 'channel',
            name: 'Channel',
            type: 'column',
            labels: {
              visible: true,
              color: '#848484',
              font: '10px Roboto !important',
              template: '# kendo.culture("en-US") # #= kendo.toString(Number(value) / 1000000, "n2") #',
              visual: function (e) {
                if (parseInt(e.text) > 0) {
                  return e.createVisual()
                }
              }
            }
          }
        ],
        title: {
          text: 'SALES BY CHANNEL CURRENT MONTH (VALUE IN MILLION)',
          align: 'left',
          color: '#000',
          font: '14px inherit !important'
        },
        categoryAxis: {
          color: '#848484',
          labels: {
            font: '10px Roboto !important'
          },
          line: {
            color: '#EAEAEA'
          },
          majorGridLines: {
            width: 0,
            color: 'transparent'
          },
          minorGridLines: {
            width: 0,
            color: 'transparent'
          }
        },
        chartArea: {
          background: '#FFFFFF',
          margin: {
            bottom: 0,
            right: 0
          }
        },
        legend: {
          visible: false
        }
      },
      product: {
        schema: {
          data: 'data'
        },
        series: [
          {
            field: 'total_sales',
            categoryField: 'product',
            name: 'Product',
            type: 'column',
            labels: {
              visible: true,
              color: '#848484',
              font: '10px Roboto !important',
              template: '# kendo.culture("en-US") # #= kendo.toString(Number(value) / 1000, "n2") #'
            }
          }
        ],
        title: {
          text: 'TOP SALES QUANTITY BY PRODUCT (VALUE IN THOUSAND)',
          align: 'left',
          color: '#000',
          font: '14px inherit !important'
        },
        valueAxis: {
          labels: {
            visible: false,
            border: {
              color: 'transparent'
            },
            color: '#848484',
            font: '10px Roboto !important',
            template: '#= kendo.toString(value / 1000000) #M'
          },
          line: {
            visible: false,
            color: 'transparent',
            width: 0
          },
          majorGridLines: {
            width: 0,
            color: 'transparent'
          },
          minorGridLines: {
            width: 0,
            color: 'transparent'
          }
        },
        categoryAxis: {
          color: '#848484',
          labels: {
            font: '10px Roboto !important'
          },
          line: {
            color: '#EAEAEA'
          },
          majorGridLines: {
            width: 0,
            color: 'transparent'
          },
          minorGridLines: {
            width: 0,
            color: 'transparent'
          }
        }
      },
      salesPerson: {
        schema: {
          data: 'data'
        },
        series: [
          {
            field: 'price',
            categoryField: 'sales_person',
            name: 'Sales Person',
            type: 'column',
            labels: {
              visible: true,
              color: '#848484',
              font: '10px Roboto !important',
              template: '# kendo.culture("en-US") # #= kendo.toString(Number(value) / 1000000, "n2") #'
            }
          }
        ],
        title: {
          text: 'TOP SALES PERSON BY SALES (VALUE IN MILLION)',
          align: 'left',
          color: '#000',
          font: '14px inherit !important'
        },
        valueAxis: {
          labels: {
            visible: false,
            border: {
              color: 'transparent'
            },
            color: '#848484',
            font: '10px Roboto !important',
            template: '#= kendo.toString(value / 1000000) #M'
          },
          line: {
            visible: false,
            color: 'transparent',
            width: 0
          },
          majorGridLines: {
            width: 0,
            color: 'transparent'
          },
          minorGridLines: {
            width: 0,
            color: 'transparent'
          }
        },
        categoryAxis: {
          color: '#848484',
          labels: {
            font: '10px Roboto !important'
          },
          line: {
            color: '#EAEAEA'
          },
          majorGridLines: {
            width: 0,
            color: 'transparent'
          },
          minorGridLines: {
            width: 0,
            color: 'transparent'
          }
        }
      }
    }
  },
  created () {
    // change button
    this.$parent.button = this.button
  },
  methods: {
    onDateSelected (event) {
      console.log(event)
      this.start = event.start
      this.end = event.end
      this.$refs.salesreport.kendoWidget().read()
      this.$refs.channelreport.kendoWidget().read()
      this.$refs.topProduct.kendoWidget().read()
      this.$refs.topCS.kendoWidget().read()
    },
    getPresetRange () {
      const n = new Date()
      return {
        thisMonth: function () {
          return {
            label: 'Bulan Ini',
            active: true,
            dateRange: {
              start: new Date(n.getFullYear(), n.getMonth(), 2),
              end: new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1)
            }
          }
        },
        lastMonth: function () {
          return {
            label: 'Bulan Lalu',
            active: false,
            dateRange: {
              start: new Date(n.getFullYear(), n.getMonth() - 1, 1),
              end: new Date(n.getFullYear(), n.getMonth(), n.getDate() - n.getDate() + 1)
            }
          }
        },
        last7days: function () {
          return {
            label: '7 Hari Terakhir',
            active: false,
            dateRange: {
              start: new Date(n.getFullYear(), n.getMonth(), n.getDate() - 7),
              end: new Date(n.getFullYear(), n.getMonth(), n.getDate())
            }
          }
        },
        last30days: function () {
          return {
            label: '30 Hari Terakhir',
            active: false,
            dateRange: {
              start: new Date(n.getFullYear(), n.getMonth(), n.getDate() - 30),
              end: new Date(n.getFullYear(), n.getMonth(), n.getDate())
            }
          }
        },
        thisYear: function () {
          return {
            label: 'Tahun Ini',
            active: false,
            dateRange: {
              start: new Date(n.getFullYear(), 0, 2),
              end: new Date(n.getFullYear(), 11, 32)
            }
          }
        }
      }
    },
    salesReport (event) {
      var vm = this
      var currentDate = moment(vm.end)
      var initialDate = moment(vm.start)
      vm.axios.get('api/report/sales/types/?date=' + encodeURIComponent(initialDate.format('YYYYMMDD') + ';' + currentDate.format('YYYYMMDD')))
        .then(
          (response) => {
            event.success(response)
          }
        )
    },
    channelReport (event) {
      var vm = this
      var currentDate = moment(vm.end)
      var initialDate = moment(vm.start)
      vm.axios.get('api/report/sales/channels/?date=' + encodeURIComponent(initialDate.format('YYYYMMDD') + ';' + currentDate.format('YYYYMMDD')))
        .then(
          (response) => {
            // console.log(response)
            event.success(response)
          }
        )
    },
    topProduct (event) {
      var vm = this
      var currentDate = moment(vm.end)
      var initialDate = moment(vm.start)
      vm.axios.get('api/report/sales/top/products/?date=' + encodeURIComponent(initialDate.format('YYYYMMDD') + ';' + currentDate.format('YYYYMMDD')))
        .then(
          (response) => {
            // console.log(response)
            event.success(response)
          }
        )
    },
    topCS (event) {
      var vm = this
      var currentDate = moment(vm.end)
      var initialDate = moment(vm.start)
      vm.axios.get('api/report/sales/top/cs/?date=' + encodeURIComponent(initialDate.format('YYYYMMDD') + ';' + currentDate.format('YYYYMMDD')))
        .then(
          (response) => {
            // console.log(response)
            event.success(response)
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Dashboard.vue